module.exports = __webpack_public_path__ + "img/Alejandro_Onate.7b0bda34.webp";